import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@root/shared/service/translate.service';
import { HttpClient } from '@angular/common/http';
import _ from 'lodash';
import { PlatformInfo } from '@root/config';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
@Component({
  selector: 'host-oversale-calendar',
  templateUrl: 'oversale-calendar.component.html',
  styleUrls: ['./oversale-calendar.component.scss'],
})
export class OversaleCalendarComponent implements OnInit {
  private readonly HolidayListApi = '/api/calendar/quick_location_date';
  @Input() showChannel = true;
  tabIndex = 0;
  selectedDates: string[] = [];
  selectedChannels: number[] = [];
  holidayList = [];

  channelOptions = _.values(PlatformInfo)
    .filter((c) => c.show)
    .map((c) => ({
      label: c.name,
      value: c.type,
    }));

  get isContinuous() {
    return this.tabIndex !== 0;
  }
  get selectedDatesInfo() {
    const length = this.selectedDates.length;
    if (!length) {
      return null;
    }
    return this.t.t(
      length > 1 ? 'component.search.selected_discontinuous_nights' : 'component.search.selected_discontinuous_night',
      {
        start: this.selectedDates[0],
        end: this.selectedDates[length - 1],
        len: length,
      }
    );
  }

  constructor(
    private t: TranslateService,
    private http: HttpClient,
    private msg: NzMessageService,
    private modalRef: NzModalRef
  ) {}

  ngOnInit() {
    this.fetchHolidayList();
    this.fetchChannelList();
  }

  private fetchHolidayList() {
    this.http.get(this.HolidayListApi).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.holidayList = rst?.data?.holiday_list;
      }
    });
  }

  private fetchChannelList() {
    this.http.get('/api/novice_guidance/v2/config').subscribe((rst: any) => {
      this.channelOptions = rst?.data?.channels?.map((c) => ({
        label: c.title,
        value: c.thirdparty_type,
      }));
    });
  }

  onClickHoliday(holiday) {
    const list = holiday.list;
    this.selectedDates = list.map((item) => item.date);
  }
  onTabChange() {
    this.selectedDates = [];
  }

  onCancel() {
    this.modalRef.destroy();
  }

  onConfirm() {
    if (!this.selectedDates.length) {
      return this.msg.warning(this.t.syncGet('warning.house.set_overbooking_date_required'));
    }
    this.modalRef.destroy({
      dates: this.selectedDates,
      channels: this.selectedChannels,
    });
  }
}
